import { ReactNode } from "react";
import { atomic } from "../atomic.css";
import { Icon, IconName } from "../icon";
import { IconButton } from "../icon-button";

export function ContentView(props: {
  heading: string;
  children: ReactNode;
  icon: IconName;
  backHref: string;
  menu?: ReactNode;
}) {
  return (
    <div
      className={atomic({
        transition: "all",
        paddingBlockStart: {
          default: 24,
          small: 32,
          medium: 32,
        },
        paddingInline: {
          default: 24,
          small: 32,
          medium: 56,
        },
        paddingBlockEnd: {
          default: 32,
          medium: 56,
        },
      })}
    >
      <div
        className={atomic({
          display: { default: "block", medium: "none" },
          blockSize: "mobile-nav",
        })}
      />

      <div
        className={atomic({
          position: {
            default: "fixed",
            medium: "relative",
          },

          padding: {
            default: 24,
            medium: 0,
          },
          inset: "top",
          display: "flex",
          transition: "all",

          marginBlockEnd: {
            default: 0,
            medium: 32,
          },

          backgroundColor: {
            default: "background-secondary",
            medium: "inherit",
          },
          zIndex: "nav",
        })}
      >
        <IconButton href={props.backHref} icon={props.icon} label="Back" />

        <Icon name="divider" className={atomic({ marginInlineStart: 6 })} />

        <div
          className={atomic({
            fontFamily: "arboria",
            fontSize: 18,
            textTransform: "uppercase",
            marginInlineStart: 6,
          })}
        >
          {props.heading}
        </div>

        {props.menu && (
          <div className={atomic({ marginInlineStart: "auto" })}>
            {props.menu}
          </div>
        )}
      </div>

      {props.children}
    </div>
  );
}
